<template>
    <div v-if="isDev" class="fps-viewer">FPS: {{ fps }}</div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";

    // 本地调试和测试环境
    const isDev = process.env.NODE_ENV === "development" || location.origin.includes("dev.edrawmax");

    @Component({
        components: {},
    })
    export default class FpsViewer extends Vue {
        isDev = isDev;
        fps = 0;
        lastTime = 0;
        fpsInterVal = 20; // fps监听间隔次数
        fpsCount = 0; // fps监听间隔计数

        getFps() {
            this.fpsCount++;
            const nowTime = performance.now();
            if (this.fpsCount >= this.fpsInterVal) {
                this.fps = Math.round((1000 * this.fpsCount) / (nowTime - this.lastTime));
                this.lastTime = nowTime;
                this.fpsCount = 0;
            }

            window.requestAnimationFrame(this.getFps);
        }

        mounted() {
            if (isDev) {
                this.getFps();
            }
        }
    }
</script>

<style lang="less" scoped>
    .fps-viewer {
        position: fixed;
        z-index: 101;
        top: 100px;
        left: 310px;
        font-size: 24px;
        color: green;
    }
</style>
